module.exports = __webpack_public_path__ + "img/prayer-journal_B095GL6S73.aa48f727.jpg";